import { Download } from '@mui/icons-material'
import { Button, CircularProgress, IconButton, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { XCircle } from '@phosphor-icons/react'
import { CustomModalContext } from 'common/contexts/CustomModalContext'
import FilesHelper from 'common/libs/Files'
import { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { downloadFile } from '../libs/FilesHelper'

const DocumentViewer = ({ title, token }) => {
  const [document, setDocument] = useState(null)
  const { handleModal } = useContext(CustomModalContext)
  const [error, setError] = useState(true)
  const [loading, setLoading] = useState(false)

  const fetchDocument = useCallback(async () => {
    if (loading) return

    setLoading(true)

    try {
      setError(false)

      const data = await downloadFile(token, 'S')

      if (!data.fichero) setError(true)
      setDocument(data)
    } catch (error) {
      setError(true)
    } finally {
      setLoading(false)
    }
  }, [token])

  useEffect(() => {
    fetchDocument()
  }, [fetchDocument])

  const blobUrl = useMemo(() => {
    if (document && (document.pdf || document.fichero)) {
      const data = `${document?.pdf ?? document?.fichero}`
      return data
    }
    return null
  }, [document])

  return (
    <Box
      sx={{
        width: '90vw',
        height: '90vh',
        backgroundColor: 'background.default',
        display: 'flex',
        flexGrow: 1,
        flexDirection: 'column',
        p: '1px',
      }}
    >
      <Box
        sx={{
          width: '90vw',
          px: 2,
          py: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography>{title}</Typography>
        <IconButton
          onClick={() => {
            handleModal({ enabled: false })
          }}
        >
          <XCircle />
        </IconButton>
      </Box>
      <Box
        sx={{
          height: '100%',
          width: '100%',
          display: 'grid',
          placeItems: 'center',
          backgroundColor: 'background.paper',
        }}
      >
        {blobUrl ? (
          <iframe
            title={title}
            src={FilesHelper.urlBase64String(blobUrl, 'application/pdf')}
            width="100%"
            height="100%"
          />
        ) : !error ? (
          <CircularProgress />
        ) : (
          <Typography sx={{ fontSize: '2em', opacity: 0.7 }}>
            No tiene permisos para visualizar este archivo
          </Typography>
        )}
      </Box>
      <Box sx={{ p: 0.3, display: 'flex', justifyContent: 'space-between' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            width: '100%',
          }}
        >
          <Button
            onClick={() => {
              FilesHelper.downloadBase64String(document.fichero, document.nombre_archivo)
            }}
            startIcon={<Download />}
            variant="outlined"
          >
            Descargar
          </Button>
        </Box>
      </Box>
    </Box>
  )
}

export default DocumentViewer
